import { Directive, effect, ElementRef, inject, input, output } from '@angular/core';

import { Breadcrumb } from '@spartacus/core';

@Directive({
  selector: '[dpActiveFacetsHeightMonitor]',
  standalone: true
})
export class DpActiveFacetsHeightMonitorDirective {
  maxHeight = input<number>(0);
  activeFacets = input.required<Breadcrumb[]>();

  heightChanged = output<boolean>();
  readonly #elementRef = inject(ElementRef);

  constructor() {
    effect(() => {
      if (this.activeFacets().length > 2) {
        this.#checkHeight();
      } else {
        this.heightChanged.emit(false);
      }
    });
  }

  #checkHeight(): void {
    const elementHeight = this.#elementRef.nativeElement.offsetHeight;
    if (elementHeight > this.maxHeight()) {
      this.heightChanged.emit(true);
    }
  }
}
